export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12411.af87f70f.jpg";